import Header from './components/Header';
import Hero from './components/Hero';
import Ranking from './components/Ranking';
import AppEntry from './components/AppEntry';
import Cards from './components/Cards';
import Topics from './components/Topics';
import Faq from './components/Faq';
import Updates from './components/Updates';
import Comments from './components/Comments';
import About from './components/About';
import Index from './components/Index';
import Media from './components/Media';
import Features from './components/Features';
import Contact from './components/Contact';
import Carousel from './components/Carousel';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Ranking />
        <AppEntry />
        <Cards />
        <Topics />
        <Faq />
        <Updates />
        <Comments />
        <About />
        <Index />
        <Media />
        <Features />
        <Contact />
        <Carousel />
      </main>
      <Footer />
    </>
  );
}